import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const DealsModelSchema = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    deal_type: z.string().nullish(),
    pipeline_stage_id: z.string().nullish(),
    pipeline_stage_date: z.string().nullish(),
    lane_priority: z.number().nullish(),
    allocation_available: z.number().nullish(),
    exchange_rate: z.number().nullish(),
    currency: z.string().nullish(),
    account: z.string().nullish(),
    pipeline_origination: z.string().nullish(),
    pipeline_execution: z.string().nullish(),
    round: z.string().nullish(),
    is_funding_round: z.boolean().nullish()
  })
  .strict()

export const DealsModelFields = makeFieldKeys(DealsModelSchema)

export type DealsModel = z.infer<typeof DealsModelSchema>

function validateDealsModel(data: unknown): DealsModel {
  try {
    return validateWithZodSchema(DealsModelSchema, data, 'deals model')
  } catch (error) {
    throw new Error(`Deals model validation failed: ${error}`)
  }
}
